jQuery(function () {

    /*===============================================
        ImgLiquid
    ==================================================*/

    if (jQuery.fn.imgLiquid) {
        jQuery(".home-banner-image,.featured-image-holder,.testimonial-bg-image,.browser-banner-img,.project-img-inner,.checkout-banner-image,.text-right-outer .featured-image").imgLiquid();

        jQuery(window).bind("debouncedresize", function () {
            jQuery(".home-banner-image,.featured-image-holder,.testimonial-bg-image,.browser-banner-img,.project-img-inner,.checkout-banner-image").imgLiquid();
        });
    }


    /* ============================================
        bPopup
    ================================================ */

    jQuery('.popup-btn').click(function (e) {
        e.preventDefault();
        var id = jQuery(this).attr('data-id');
        jQuery('#' + id).bPopup();
    });

    /* ============================================
        Popover
    ================================================ */

     // jQuery("[data-toggle=popover]").each(function(i, obj) {
     //        jQuery(this).popover({
     //          html: true,
     //          content: function() {
     //            var id = jQuery(this).attr('id')
     //            return jQuery('#popover-content-' + id).html();
     //          }
     //        });
     //
     //    });



    /*============================================
       matchheight
	============================================ */

    if (jQuery.fn.matchHeight) {
        jQuery('.project-section .project-blk-outer .project-block .project-content .project-content-inner h5.title-5').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }
    if (jQuery.fn.matchHeight) {
        jQuery('.project-section .project-blk-outer .project-block .project-content .project-content-inner p.paragraph').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }    
    if (jQuery.fn.matchHeight) {
        jQuery('.project-section .project-blk-outer .project-block .project-content .project-content-inner').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }
    if (jQuery.fn.matchHeight) {
        jQuery('.eq-height').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }    


    /*============================================
	   Skill Bar
	============================================ */

    jQuery(document).ready(function () {
        jQuery('.progress .progress-bar').css("width",
            function () {
                return jQuery(this).attr("aria-valuenow") + "%";
            }
        )
    });

    /*===============================================
        Button click dropdowns
    ==================================================*/
	// jQuery(".add-teacher-btn .solid-btn").click(function (event) {
	// 	jQuery(".add-teacher-block").addClass("active");
	// });
	jQuery(".fund-result-btn .solid-btn").click(function (event) {
		jQuery(".fund-search-filter").toggleClass("active");
	});
	jQuery(".teacher-fund-btn .solid-btn").click(function (event) {
		jQuery(".fundraising-popup").toggleClass("active");
	});
												
    /*===============================================
        Slick
    ==================================================*/
    if (jQuery.fn.slick) {
        //featured-slider-outer ul
        jQuery('.featured-slider-outer ul').slick({
            dots: true,
            prevArrow: "<span class='slick-prev pull-left'></span>",
            nextArrow: "<span class='slick-next pull-right'></span>",
            customPaging: function (slider, i) {
                return '<span></span>';
            }
        });
        
        
        
         $('.testimonial-container ul').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
			autoplay: true,
			autoplaySpeed: 4000,
            asNavFor: '.slider-nav-thumbnails',
         });

         $('.slider-nav-thumbnails').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.testimonial-container ul',
            dots: true,
            focusOnSelect: true
         });

         // Remove active class from all thumbnail slides
         $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

         // Set active class to first thumbnail slides
         $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

         // On before slide change match active thumbnail to current slide
         $('.testimonial-container ul').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var mySlideNumber = nextSlide;
            $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
            $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
		 });
		 
		 $('.testimonial-container ul').on('afterChange', function (event, slick, currentSlide) {
			$('.slick-slide .radial-progress-border').html('');
		 });
		 
		 $('.testimonial-container ul').on('setPosition', function (event, slick) {	
		 
			// $('.slick-slide.slick-current .radial-progress-border').html('');
			
			// var radialObj2 = $('.slick-slide.slick-current .radial-progress-border').radialIndicator({
			// 	showPercentage : false,
			// 	radius : 35,
			// 	barWidth : 4,
			// 	barBgColor: 'transparent',
			// 	barColor: '#d9232f',
			// 	displayNumber: false,
			// 	percentage: true
			// }).data('radialIndicator');
			
			// radialObj2.animate(slick.options.autoplaySpeed);
			
			var up = true;
			var value = 0;
			var increment = 1;
			var ceiling = 400;

			function PerformCalc() {
			  if (up == true && value <= ceiling) {
				value += increment

				if (value == ceiling) {
				  up = false;
				}
			  } else {
				  up = false
				  value -= increment;

				  if (value == 0) {
					up = true;
				  }
			  }

			  // console.log(value);
			//   radialObj2.animate(value);
			}
			setInterval(PerformCalc, 38);
			
        });
		
		
			

        
    }


    /*============================================
       Selectbox
    ============================================ */
    if (jQuery.fn.selectbox) {
        jQuery(".select-box").selectbox({
            onOpen: function () {
                jQuery('.select-outer').addClass('active');
            },

            onClose: function () {
                jQuery('.select-outer').removeClass('active');
            }
        });
    }

    /*============================================
       Favorite Checkbox
    ============================================ */
    jQuery('.fav-check,.fav-excerpt-check').click(function (e) {
        e.preventDefault();
        jQuery(this).toggleClass('clicked');
    });


    /*============================================
       Range Slider
    ============================================ */
    // jQuery('.percentage-slider').each(function () {
    //     var $projectBar = jQuery(this).find('.bar');
    //     var $projectPercent = jQuery(this).find('.percent');
    //     var $projectRange = jQuery(this).find('.ui-slider-range');
    //     $projectBar.slider({
    //         range: "min",
    //         animate: true,
    //         value: 20,
    //         min: 0,
    //         max: 100,
    //         step: 1,
    //         slide: function (event, ui) {
    //             $projectPercent.val(ui.value + "%");
    //         }
    //     });
    // });
   

    /*============================================
       easyresponsive tabs
    ============================================ */
     // if (jQuery.fn.easyResponsiveTabs) {
     //    jQuery('.tab-section').easyResponsiveTabs({
     //        type: 'default', //Types: default, vertical, accordion
     //        width: 'auto', //auto or any width like 600px
     //        fit: true,   // 100% fit in a container
     //        closed: 'accordion', // Start closed if in accordion view
     //        activate: function(event) { // Callback function if tab is switched
     //        var $tab = $(this);
     //        var $info = $('#tabInfo');
     //        var $name = $('span', $info);
     //        $name.text($tab.text());
     //        $info.show();
     //        }
     //    });
     // }

     //mobile menu
     jQuery('button.mobile-button').click(function (e) {
        e.preventDefault();
        jQuery(this).toggleClass('open');
        jQuery('body').toggleClass('active');
        jQuery('.main-nav .right-nav').slideToggle();
    });
   

});



// WEBPACK FOOTER //
// ./resources/js/vendor/main.js